<template>
    <rkm-area
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-form-checkbox v-model="data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao">
                Habilitar agendamento de exames de imagem no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite disponibilizar vagas de agendamento de exames de imagem    no App do Cidadão. Quando desativado, o agendamento não é exibido no App, mesmo que esteja configurado.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>
        <rkm-row>
            <rkm-form-checkbox v-model="data.model.integracaoAplicativo.habilitaConsultaImagemConectasusCidadao">
                Habilitar visualização de laudos de exames de imagem no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite que o cidadão visualize laudos de exames de imagem com resultado emitido no App do Cidadão. Quando desativado, os laudos não são exibidos no App.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>
    </rkm-area>
</template>
<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
}
</script>
<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>